import { render } from "./TestQuestions.vue?vue&type=template&id=e434deb0&scoped=true"
import script from "./TestQuestions.vue?vue&type=script&lang=js"
export * from "./TestQuestions.vue?vue&type=script&lang=js"

import "./TestQuestions.vue?vue&type=style&index=0&id=e434deb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e434deb0"]])

export default __exports__